// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { Tab } from 'bootstrap';
import { Link as Scroll } from 'react-scroll';
import jwt_decode from 'jwt-decode';
import { useCookies } from 'react-cookie';
import { Helmet } from 'react-helmet-async';

// ヘッダー
import Header from '../component/page_parts/header';

// フッター
import Footer from '../component/page_parts/footer';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

//json読み込み
import name2Json from '../files/division.json';

import { Link } from "react-router-dom";

// パンくずリスト
import TableOfContents from "../component/page_parts/common/table_of_contents";

function Media() {

  const [json2, set2Json] = useState(name2Json);
  // console.log(json[0].name);
  //console.log(json[6].department)

  /* 配信先指定と認証に必要なstate */
  // Cookieから取得したトークンを保持
  const [cookies, setCookie, removeCookie] = useCookies(["sessionToken"]);
  // トークンをデコードして取得したjtiを保持（パラメータに付与する用）
  const [cookieJti, setCookieJti] = useState();


  // activeの切替 ※適当に引っ張ってきた状態なので、classとかmyTabみたいな名称とかは適宜直したい
  // https://getbootstrap.jp/docs/5.0/components/navs-tabs/
  var triggerTabList = [].slice.call(document.querySelectorAll('#myTab button'));
  triggerTabList.forEach(function (triggerEl) {
    // var tabTrigger = new bootstrap.Tab(triggerEl);
    var tabTrigger = new Tab(triggerEl);

    triggerEl.addEventListener('click', function (event) {
      event.preventDefault();
      tabTrigger.show();
    });
  });

  //restAPI取得
  const [posts, setPosts] = useState([]);

  // WP RESTAPI 環境別ベースURL
  const urlBase = process.env.REACT_APP_WP_REST_API_PATH_MEDIA;

  const baseUrl = process.env.REACT_APP_PUBLIC_URL;

  // ログイン時に生成されたトークンをデコードしたデータをstateに格納
  useEffect(() => {
    // console.log('cookieJti 1: ', cookieJti);
    if (cookieJti === undefined) {
      SettingLonginData();
    }
  }, []);

  /* ログイン時に生成されたトークンをデコードしたデータをstateに保持 */
  function SettingLonginData() {
    // console.log('【実行】SettingLonginData');
    // Cookieからトークンを取得
    const token = cookies.sessionToken;
    // デコード
    const decodedToken = jwt_decode<{ [name: string]: string }>(token);
    // console.log(decodedToken);

    /* パラメータ（zenken）にセットしてリクエストするためのjtiの値を取得してstateにセット
    →WP側で値の確認を行う（確認できないリクエストには401を返すようにする）*/
    setCookieJti(decodedToken.jti);
  }

  useEffect(() => {

    var wpRestUrl = urlBase + 'wp-json/wp/v2/posts?per_page=100&zenken='

    if (cookieJti !== undefined) {
      const fetchUrl = wpRestUrl + cookieJti;
      fetch(fetchUrl, { method: 'GET' })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          setPosts(data)
          category(data)
        })
    }
  }, [cookieJti])

  const [mediaName, setMediaName] = useState([]);
  const [jsonData_name, setJsonData_name] = useState([]);

  const category = (data) => {
    /*やりたいこと
    *jsonからnameを取り出す
    *カテゴリーをキーにして、ソートして、jsonを分ける
    *分けたjsonを表示する
    */
    //nameを取り出す
    var namevalue = data.map((data) => data.media_department.name);

    //重複を削除
    // var category_value_unique = category_value.filter(
    //   (x, i, self) => self.indexOf(x) === i
    // );

    //重複を削除したカテゴリーをstateに格納
    setMediaName(namevalue);
    //restAPIのname
    //  console.log(namevalue);

    var data_sort = [];
    //投稿の数だけfor文を回す
    for (let i = 0; i < namevalue.length; i++) {
      //投稿の名前をキーにして、jsonを分ける
      var json_name = data.filter(
        (data) => data.media_department.name === namevalue[i]
      );
      //投稿の名前ごとに分けたjsonを配列に格納
      data_sort.push(json_name);
    }
    //投稿の名前ごとに分けた配列をstateに格納
    setJsonData_name(data_sort);
  };

  // console.log(jsonData_name);

  // {json.map((media) => 
  //   posts.map((json) => (
  //     json.media_department.name === media.name && json.acf.media_sns.twitter !== "" ?(
  //     console.log(json.title.rendered)
  //     ): (
  //       <></>
  //     )
  //   )
  // ))}
  // console.log(media_data)

  //name取り出し
  // {posts.map((json) => (
  //   console.log(json.title.rendered)
  // ))}

  var toukouName = json2.map((data) => data.department);
  var toukouName2 = posts.map((data) => data.media_department);
  // console.log(toukouName);
  // console.log(toukouName);


  //データの受け渡しテスト



  return (
    <>
      <Helmet>
        <title>Z-link メディア一覧</title>
      </Helmet>
      <Header />
      <div className="theme-division">
      <div className="content-header">
          <div className="container">
            <Row>
              <Col sm={12}>
                <h1 className='page-title type-media'>メディア一覧</h1>{/* ページタイトル */}
              </Col>
            </Row>
          </div>
        </div >
        < TableOfContents />
        <div className="container division-area">
          <div className="row">
            <div className="col-left col-sm-3">
              <div className="list-group nav nav-tabs" id="myTab" role="tablist">
                {json2.map(group => (
                  <div className="group-box" key={group.department_id}>
                    <div className="depName">{group.name}</div>
                    {group.department
                      .filter(section => {
                        return posts.some(post =>
                          post.media_department.name === section.name ||
                          post.media_department.second_name === section.name
                        );
                      })
                      .map(section => (
                        <Scroll
                          key={section.id}
                          to={section.slug}
                          smooth={true}
                          duration={600}
                          offset={-90}
                        >
                          <button
                            type="button"
                            className={`division-name list-group-item list-group-item-action nav-link ${section.state}`}
                            id={section.id}
                            data-bs-toggle="tab"
                            data-bs-target={`#${section.slug}`}
                            role="tab"
                            aria-controls={section.slug}
                            aria-selected="true"
                          >
                            {section.name}
                          </button>
                        </Scroll>
                      ))}
                  </div>
                ))}
              </div>
            </div>


            <div className="col-right col-sm-9">
              <div className="media-box-area">
                {json2.map(group =>
                  group.department.map(section => {
                    const filteredPosts = posts.filter(post =>
                      post.media_department.name === section.name ||
                      post.media_department.second_name === section.name
                    );

                    if (filteredPosts.length === 0) return null;

                    return (
                      <section key={section.slug}>
                        <h3 id={section.slug} className="tag-title mt-0 mb-4">
                          <span className="name2">{section.name}</span>
                        </h3>
                        <div className="media-box">
                          {filteredPosts.map(post => (
                            <div key={post.id} className="card media-list">
                              <a href={post.acf.media_url} target="_blank" rel="noopener noreferrer">
                                <div className="media-logo">
                                  <img
                                    src={post.acf.media_img.logo || post.acf.media_img.capture}
                                    alt="キャプチャ画像"
                                  />
                                </div>
                                <div className="media-title">{post.title.rendered}</div>
                                <div className="media-text">{post.acf.media_description}</div>
                              </a>
                              <div className="media-sns">
                                <ul>
                                  {post.acf.media_sns.twitter && (
                                    <li>
                                      <a href={post.acf.media_sns.twitter} target="_blank" rel="noopener noreferrer">
                                        <img className='x-icon' src="./x-logo.svg" alt="X" />
                                      </a>
                                    </li>
                                  )}
                                  {post.acf.media_sns.instagram && (
                                    <li>
                                      <a href={post.acf.media_sns.instagram} target="_blank" rel="noopener noreferrer">
                                        <img src="./instagram.svg" alt="Instagram" />
                                      </a>
                                    </li>
                                  )}
                                  {post.acf.media_sns.facebook && (
                                    <li>
                                      <a href={post.acf.media_sns.facebook} target="_blank" rel="noopener noreferrer">
                                        <img src="./facebook.svg" alt="Facebook" />
                                      </a>
                                    </li>
                                  )}
                                  {post.acf.media_sns.youtube && (
                                    <li>
                                      <a href={post.acf.media_sns.youtube} target="_blank" rel="noopener noreferrer">
                                        <img src="./yutube.svg" alt="YouTube" />
                                      </a>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </div>
                          ))}
                        </div>
                      </section>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );


}

export default Media;